import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import * as Sentry from "@sentry/react";
import { HOST } from "Constant/Constant";
import { getQueryString } from "Constant/utils";
import { getAvailableProducts } from "store/reducer/get-available-products";

export const importExportProductsApi = createApi({
  reducerPath: "importExportProductsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: HOST,
  }),

  endpoints: (builder) => ({
    getAvailableProducts: builder.mutation({
      query: (getQueryParams) =>
      {
        return {
          url: `/get-available-products${getQueryString(getQueryParams)}`,
          method: "GET",
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      },
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
            const response = await queryFulfilled;
            dispatch(getAvailableProducts({data: response?.data})
          );
        } catch (error) {
          console.error(">>>>>importExportProductsApi error", error);
          Sentry.addBreadcrumb({ category: "api", message: "getAvailableProducts mutation failed", level: "error", data: { error } });
          dispatch(getAvailableProducts({ data: [] }));
        }
      },
    }),

    exportProducts: builder.mutation({
      query: (getQueryParams) =>
      {
        return {
          url: `/export-products`,
          method: "POST",
          body: getQueryParams,
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      },
    }),

    importProducts: builder.mutation({
      query: (getImportedProductFile) =>
      {
        return {
          url: `/import-products`,
          method: "POST",
          body: {"productIds": getImportedProductFile?.productIds},
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
            siteId: getImportedProductFile?.siteId ?? '',
          },
        }
      },
    }),

  }),
})

export const { useGetAvailableProductsMutation, useExportProductsMutation, useImportProductsMutation } = importExportProductsApi;
